import { ThemeButtonIcon } from '@shared/ui/buttons';
import { useHelpDialog } from '@utils/dialogs-hooks';

export default function HelpBtn({ page }) {
  const { openHelpDialog } = useHelpDialog({ page });

  if (page !== 'referrals') return null;

  return <ThemeButtonIcon icon="help" onClick={openHelpDialog} />;
}
